import React from "react";

import Button from "../../Components/Button";
import CommonModal from "../../Components/Modal";
import "./style.scss";

interface FormModalProps {
  isOpen: boolean;
  toggle: () => void;
  title: string;
  onSubmit: () => void;
  children: React.ReactNode;
  submitLabel?: string;
  isEditMode?: boolean;
  loading?: boolean;
  disabled?: boolean;
}

const FormModal: React.FC<FormModalProps> = ({
  isOpen,
  toggle,
  title,
  onSubmit,
  children,
  submitLabel,
  isEditMode = false,
  loading = false,
  disabled = false,
}) => {
  return (
    <CommonModal isOpen={isOpen} toggle={toggle} title={title} size="4xl">
      <div className="form-modal">
        <div className="form-content">{children}</div>
        <div className="modal-actions">
          <Button variant="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button
            loading={loading}
            disabled={disabled}
            variant="primary"
            onClick={onSubmit}
          >
            {submitLabel || (isEditMode ? "Save Changes" : "Create")}
          </Button>
        </div>
      </div>
    </CommonModal>
  );
};

export default FormModal;
